import {RouteLocationNormalizedLoadedGeneric} from 'vue-router';
import {useUserSettingsStore} from '@/stores/apolloPlatform/userSettings/userSettings';

/**
 * Find a translation on language switch.
 * In this scenario we should have access to the previous route.
 * @see {@link apollo_portal/src/router.ts}
 */
export const findTranslationOfId = async (from: RouteLocationNormalizedLoadedGeneric) => {
  const response = await apiGetCmsPages({translation_of: from.meta.node?.id});
  const results = response?.data?.results;
  return results !== undefined && results?.length === 1 ? results[0] : undefined;
};

/**
 * Find a translation on initial load.
 * In this scenario we have nothing but the slug.
 */
export const findTranslationOfSlug = async (to: RouteLocationNormalizedLoadedGeneric) => {
  let opposite, current;
  const slugs = to.fullPath.split('/').filter(Boolean);
  let response = await apiGetCmsPages({
    locale: useUserSettingsStore().userSettings.language === 'en-US' ? 'nl' : 'en',
    slug: slugs[slugs.length - 1],
  });
  if (response?.data?.results?.length === 1) {
    opposite = response.data.results[0];
    // Does the page have a translation in the current locale?
    response = await apiGetCmsPages({translation_of: opposite.meta.id});
    if (response?.data?.results?.length === 1) current = response?.data?.results[0];
  }
  return [opposite, current];
};
